<template>
  <div>
    <div>
      <h1 class="mdn-Heading mdn-Heading--sm">Detalhes Provedor {{ nomeProvedor }}</h1>

      <template v-if="linhas.length">
        <SGPPaginacaoComponent :paginacao="paginacao" :key="paginacao?.current_page"
          @sgpAtualizarPaginacao="realizarPaginacao">
          <SGPTabelaComponent 
            :colunas="colunas"
            :dados="linhas"
            :usuarioPodeEditar="false"
            :usuarioPodeExcluir="false"
            :botaoInline="false"
            :somenteLeitura="true"
          >
            <template v-slot:item.percentual_dentro_sla="{ item }">
              {{ formatarPercentual(item.percentual_dentro_sla) }}
            </template>
          </SGPTabelaComponent>
          </SGPPaginacaoComponent>
      </template>

      <SGPAlertaComponent v-else />
      <SGPLoadingComponent v-if="loadingAnaliticosProvedor" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { formatarPercentual } from '@/common/boot/Utils'

const TIPO_DATA_PADRAO = 'data_referencia'

const TIPOS_QTD_OPCOES = [
  {
    value: 'qtd_solicitacoes_interrupcao',
    text: 'Qtd. solicitações de interrupção'
  },
  {
    value: 'qtd_interrupcoes_aprovadas',
    text: 'Qtd. interrupções aprovadas'
  },
  {
    value: 'qtd_interrupcoes_negadas',
    text: 'Qtd. interrupções negadas'
  },
  {
    value: 'qtd_procedente',
    text: 'Qtd. procedentes'
  },
  {
    value: 'qtd_improcedente',
    text: 'Qtd. improcedentes'
  },
  {
    value: 'qtd_dentro_sla',
    text: 'Qtd. dentro SLA'
  },
  {
    value: 'qtd_fora_sla',
    text: 'Qtd. Fora SLA'
  },
]

const DATA_REFERENCIA_OPCOES = [
  {
    value: 'data_referencia',
    text: 'Data livre'
  },
  {
    value: 'data_mensal',
    text: 'Data mensal'
  }
]

const TIPOS_QTD_VALUES = TIPOS_QTD_OPCOES.map((opcao) => opcao.value)
const DATA_REFERENCIA_VALUES = DATA_REFERENCIA_OPCOES.map((opcao) => opcao.value)

export default {
  name: 'DetalheProvedorAnaliticoPage',

  data() {
    return {
      filtro: {},
      nomeProvedor: '',
    }
  },

  created() {
    const {
      nomeProvedor,
      ...filtro
    } = this.$route.query

    this.nomeProvedor = nomeProvedor
    this.filtro = filtro

    this.buscarAnaliticosProvedorDetalhes()
  },

  computed: {
    ...mapGetters('ctrlAnaliticosProvedor', [
      'listaDeAnaliticosProvedor',
      'loadingAnaliticosProvedor',
      'paginacao'
    ]),

    linhas() {
      return this.listaDeAnaliticosProvedor.map((row) => ({
        ...row,
        data_referencia_fmt: this.formatarDataTabela(row.referencia_exibicao)
      }))
    },

    colunas() {
      return [
        { key: 'provedor.nome', label: 'Provedor', sortable: false },
        { key: 'data_referencia_fmt', label: 'Data referência', sortable: false },
        { key: 'provedor.responsavel', label: 'Responsável', sortable: false },
        {
          key: 'qtd_solicitacoes_interrupcao',
          label: 'Solicitações interrupção',
          sortable: false
        },
        {
          key: 'qtd_interrupcoes_aprovadas',
          label: 'Interrupções aprovadas',
          sortable: false
        },
        {
          key: 'qtd_interrupcoes_negadas',
          label: 'Interrupções negadas',
          sortable: false
        },
        { key: 'qtd_procedente', label: 'Procedente', sortable: false },
        { key: 'qtd_improcedente', label: 'Improcedente', sortable: false },
        { key: 'qtd_dentro_sla', label: 'Dentro SLA', sortable: false },
        { key: 'percentual_dentro_sla', label: '% Dentro do SLA', sortable: false },
        { key: 'qtd_fora_sla', label: 'Fora SLA', sortable: false },
        { key: 'qtd_chamados', label: 'Quantidade de Chamados', sortable: false },
        
      ]
    }
  },

  methods: {
    ...mapActions('ctrlAnaliticosProvedor', [
      'listarDetalhesAnaliticosProvedor',
    ]),

    formatarPercentual,

    obterTipoDataSelecionado() {
      return this.filtro?.tipo_data_referencia || TIPO_DATA_PADRAO
    },

    construirFiltroPayload(filtro = {}) {
      return {
        provedor_id: filtro.provedorId,
        ...this.construirFiltroData(filtro),
        ...this.construirFiltroProvedor(filtro),
        ...this.construirFiltroQuantidade(filtro),
        ...this.construirFiltroTexto(filtro, 'uf'),
        ...this.construirFiltroTexto(filtro, 'cm'),
      }
    },

    construirFiltroData(filtro = {}) {
      const tipoData = filtro.tipo_data_referencia || TIPO_DATA_PADRAO
      const valorData = filtro.valor_data_referencia

      if (!this.filtroDataValido(tipoData, valorData)) {
        return {}
      }

      if (tipoData === 'data_mensal') {
        return {
          data_mensal: valorData
        }
      }

      return {
        data_referencia: this.formatarDataFiltro(valorData)
      }
    },

    construirFiltroProvedor(filtro = {}) {
      const provedor = this.normalizarTexto(filtro.provedor)

      if (!provedor) {
        return {}
      }

      return {
        provedor
      }
    },

    construirFiltroTexto(filtro = {}, campo) {
      const valor = this.normalizarTexto(filtro[campo])

      if (!valor) {
        return {}
      }

      return {
        [campo]: valor
      }
    },

    construirFiltroQuantidade(filtro = {}) {
      const tipoQuantidade = filtro.tipo_qtd
      const valorQuantidade = this.normalizarValorQuantidade(filtro.valor_qtd)

      if (!this.filtroQuantidadeValido(tipoQuantidade, valorQuantidade)) {
        return {}
      }

      return {
        tipo_qtd: tipoQuantidade,
        valor_qtd: valorQuantidade
      }
    },

    filtroDataValido(tipoData, valorData) {
      return Boolean(
        tipoData &&
        valorData &&
        DATA_REFERENCIA_VALUES.includes(tipoData)
      )
    },

    filtroQuantidadeValido(tipoQuantidade, valorQuantidade) {
      return Boolean(
        tipoQuantidade &&
        valorQuantidade !== null &&
        TIPOS_QTD_VALUES.includes(tipoQuantidade)
      )
    },

    normalizarTexto(valor) {
      if (valor === null || valor === undefined) {
        return ''
      }

      return String(valor).trim()
    },

    normalizarValorQuantidade(valor) {
      const valorNormalizado = this.normalizarTexto(valor)

      if (!valorNormalizado) {
        return null
      }

      const numero = parseInt(valorNormalizado, 10)

      return Number.isNaN(numero) ? null : numero
    },

    formatarDataFiltro(valorData) {
      const data = moment(valorData)

      return data.isValid()
        ? data.format('YYYY-MM-DD')
        : valorData
    },

    valorDataEhMensal(valorData) {
      const valorTexto = String(valorData).trim()

      return /^\d{4}-\d{2}$/.test(valorTexto) || /^\d{2}\/\d{4}$/.test(valorTexto)
    },

    formatarDataMensal(valorData) {
      const valorTexto = String(valorData).trim()

      if (/^\d{2}\/\d{4}$/.test(valorTexto)) {
        return valorTexto
      }

      const data = moment(valorTexto, 'YYYY-MM', true)

      return data.isValid()
        ? data.format('MM/YYYY')
        : valorTexto
    },

    formatarDataTabela(valorData) {
      if (!valorData) {
        return '-'
      }

      const tipoData = this.obterTipoDataSelecionado()
      const formatoMensal = tipoData === 'data_mensal' || this.valorDataEhMensal(valorData)

      if (formatoMensal) {
        return this.formatarDataMensal(valorData)
      }

      return moment.utc(valorData).format('DD/MM/YYYY')
    },

    montarParametros(extra = {}) {
      return {
        per_page: this.obterPerPagePadrao(),
        current_page: this.obterPaginaAtualPadrao(),
        ...this.construirFiltroPayload(this.filtro),
        ...extra
      }
    },

    obterPerPagePadrao() {
      return this.paginacao?.per_page || 20
    },

    obterPaginaAtualPadrao() {
      return this.paginacao?.current_page || 1
    },

    buscarAnaliticosProvedorDetalhes(extra = {}) {
      return this.listarDetalhesAnaliticosProvedor(this.montarParametros(extra))
    },

    realizarPaginacao(paginacao) {
      const paginaAtual = paginacao.current_page || 1
      const porPagina = paginacao.per_page || this.obterPerPagePadrao()

      this.buscarAnaliticosProvedorDetalhes({
        current_page: paginaAtual,
        per_page: porPagina
      })
    },

  }
}
</script>